import React from "react";
import "./../elementPages.less";
import Distribution from "./Distribution/Distribution"; 
import CalculateTask3DYCZTable from "./calculateTask3DYCZ_table"; 
import Hydraulics from "./Hydraulics";

// 定义类型接口
interface TowerResultComponentProps {
  input: any;
  transInput: any;
  results: any;
  selectTreeButton: string;
  scrollViewRef: React.RefObject<HTMLDivElement>;
  selectResultPage: string; // "工艺计算结果" | "水力学计算"
}

const TowerResultComponent = ({
  input,
  transInput,
  results,
  selectTreeButton,
  scrollViewRef,
  selectResultPage
}: TowerResultComponentProps) => {
  // 筛选当前选中设备的结果数据
  const currentElementResult = results?.elements
    ?.filter((item: any) => item?.name === selectTreeButton)
    ?.find((item: any) => item?.result)?.result || [];

  // 筛选当前选中设备的输入数据
  const currentElementInput = input?.inputs?.elements?.filter(
    (item: any) => item?.name === selectTreeButton
  )[0];

  return (
    <div className="tower-result-container">
      {/* 根据选中的标签页渲染对应内容 */}
      {selectResultPage === "工艺计算结果" ? (
        <>
          {/* 分布数据组件 */}
          <div className="distribution-section">
            <Distribution
              inputs={transInput}
              results={currentElementResult}
            />
          </div>

          {/* 计算结果表格 */}
          <div className="table-section">
            <CalculateTask3DYCZTable
              inputData={input?.inputs?.elements?.filter(
                (item: any) => item?.name === selectTreeButton
              )}
              resultsData={results?.streams}
              streamsData={
                input?.inputs?.streams?.filter((item: any) => item?.materials.length > 0)[0]
              }
            />
          </div>

          {/* 间距占位 */}
          <div className="spacing-block"></div>
        </>
      ) : (
        // 水力学计算内容
        <div className="hydraulics-section">
          <Hydraulics
            scrollViewRef={scrollViewRef}
            results={results?.elements?.filter((item: any) => item?.name === selectTreeButton)[0]}
            inputs={currentElementInput}
          />
        </div>
      )}
    </div>
  );
};

export default TowerResultComponent;